import { render } from "./DollarIcon.vue?vue&type=template&id=00288668"
import script from "./DollarIcon.vue?vue&type=script&lang=js"
export * from "./DollarIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__